import { render, staticRenderFns } from "./dui-word-count.vue?vue&type=template&id=0c951d25&"
import script from "./dui-word-count.vue?vue&type=script&lang=js&"
export * from "./dui-word-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports